// Media Gallery Container
import { connect } from 'react-redux';
import * as FilterActions from '../../actions/filter-actions';
import * as ModalActions from '../../actions/modal-actions';
import MediaGallery from './MediaGallery';
import { getItemsFromAccount } from '../../modules/consumer-account/storage-actions';

const mapStateToProps = state => ({
  filters: state.filters,
  mediaItems: state.mediaItems,
  savedToFavorites: state.savedToFavorites,
  assetId: state.assetId,
  assetLoadComplete: state.assetLoadComplete,
  selectedFilters: state.selectedFilters,
  modal: state.modal,
  filterToggle: state.filterToggle,
});

const mapDispatchToProps = dispatch => ({
  buttonClick: (event, filterName) => dispatch(FilterActions.mediaButtonClick(event, filterName)),
  closeAllDropdowns: () => dispatch(FilterActions.closeAllDropdowns()),
  filterClick: option => dispatch(FilterActions.filterClick(option)),
  removeFilter: filterName => dispatch(FilterActions.removeFilter(filterName)),
  clearFilters: () => dispatch(FilterActions.clearSecondaryFilters()),
  openModal: (item) => {
    const {
      useLocalStorage,
      isAuthenticated,
    } = window;
    if (useLocalStorage || !isAuthenticated) {
      dispatch(ModalActions.openModal(item));
    }
    if (isAuthenticated) {
      getItemsFromAccount(
        'photo',
        (data) => {
          dispatch(ModalActions.openModal(item, data.photos));
        },
      );
    }
  },
  closeModal: item => dispatch(ModalActions.closeModal(item)),
  filterToggleClick: () => dispatch(FilterActions.filterToggleClick()),
  showAllFilterItems: (event, filterName) => dispatch(FilterActions.showAllFilterItems(event, filterName)),
});

const MediaGalleryContainer = connect(mapStateToProps, mapDispatchToProps)(MediaGallery);

export default MediaGalleryContainer;
